import type { Photographer } from "@/lib/photographers-source";

export type SelectedItem = {
  id: string;
  image: string;
  caption: string;
  photographerId: string;
  photographerName: string;
  region?: string | null;
  theme?: string | null;
  instagramHandle?: string | null;
  websiteUrl?: string | null;
};

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return h;
}

export function pickWorks(photographers: Photographer[], count: number, seed: number): SelectedItem[] {
  const pool: SelectedItem[] = [];
  photographers.forEach((p) => {
    p.gallery.forEach((src, i) => {
      pool.push({
        id: `${p.id}-${i}`,
        image: src,
        caption: p.city ?? p.region ?? p.name,
        photographerId: p.id,
        photographerName: p.name,
        region: p.city ?? p.region ?? null,
        theme: p.galleryThemes?.[i] ?? p.themes?.[0] ?? null,
        instagramHandle: p.instagramHandle ?? null,
        websiteUrl: p.websiteUrl ?? null,
      });
    });
  });
  const shuffled = [...pool].sort((a, b) => hash(a.id + seed) - hash(b.id + seed));
  return shuffled.slice(0, count);
}

export function getISOWeek(date: Date): { week: number; year: number } {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return { week, year: d.getUTCFullYear() };
}

export function weekSeed(year: number, week: number) {
  return year * 100 + week;
}